import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  message: '',
  data: []
};

export const showroomCategorySlice = createSlice({
  name: 'showroomCategory',
  initialState,
  reducers: {
    addShowroomCategory: (state) => {
      state.loading = true;
    },
    getShowroomCategory: (state) => {
      state.loading = true;
    },
    successShowroomCategory: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    failedShowroomCategory: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    removeShowroomCategory: (state) => {
      state.loading = true;
    },
    updateShowroomCategory: (state) => {
      state.loading = true;
    }
  }
});

export const {
  addShowroomCategory,
  removeShowroomCategory,
  updateShowroomCategory,
  getShowroomCategory,
  successShowroomCategory,
  failedShowroomCategory
} = showroomCategorySlice.actions;

export default showroomCategorySlice.reducer;
